import React from "react";
import ProfilePhoto from "../../../Profile/UserDetails/ProfilePhoto";
import { TrashIcon, UploadNew } from "../../../Icon";
import { InputDetailsErrorType } from "./index";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RollingLoader } from "../../../commons";
import Select from "react-select";
import { GENDER_STATUS } from "../../../../constant/userProfileConstant";
import { DropDownType } from "../../../../commonTypes/clientDirectoryTypes";
type AppProps = {
  data: any;
  setCandidateDetails: any;
  isEdit: boolean;
  applicantDetails: any;
  inputDetailsError: InputDetailsErrorType;
  handleBasicDetailsInput: (
    data: any,
    section: string,
    name: string,
    type?: string
  ) => void;
  handleOpenPreview: (data: any) => void;
  handleResumeToggleUploadModal: (data: any) => void;
  handleDeleteResume: () => void;
  isEditData?: boolean;
  candidateDetails: any;
  limit: number;
  recruitmentTrackerUniqueEmailFetching: boolean;
  recruitmentTrackerUniqueEmailMessage: string | null;
  recruitmentTrackerUniqueMobileFetching: boolean;
  recruitmentTrackerUniqueMobileMessage: string | null;
  finalSkillList: DropDownType[] | [];
  finalQualificationList: DropDownType[] | [];
  setSkillsOffset: React.Dispatch<React.SetStateAction<number>>;
  setQualificationOffset: React.Dispatch<React.SetStateAction<number>>;
  setQualificationText: React.Dispatch<React.SetStateAction<string>>;
  setSkillsText: React.Dispatch<React.SetStateAction<string>>;
  skillsText: string;
  qualificationText: string;
  branchFetching: boolean;
};
const CandidateInformation = ({
  data,
  setCandidateDetails,
  isEdit,
  limit,
  applicantDetails,
  inputDetailsError,
  handleBasicDetailsInput,
  handleOpenPreview,
  handleResumeToggleUploadModal,
  handleDeleteResume,
  isEditData,
  candidateDetails,
  recruitmentTrackerUniqueEmailFetching,
  recruitmentTrackerUniqueEmailMessage,
  recruitmentTrackerUniqueMobileFetching,
  recruitmentTrackerUniqueMobileMessage,
  finalQualificationList,
  finalSkillList,
  setSkillsOffset,
  setQualificationOffset,
  setQualificationText,
  skillsText,
  qualificationText,
  setSkillsText,
  branchFetching
}: AppProps) => {

  const checkQualificationBottom = () => {
    setQualificationOffset((prev: number) => prev + limit)
  }

  const checkSkillsBottom = () => {
    setSkillsOffset((prev: number) => prev + limit)
  }

  return (
    <>
      <div className="user-profile-form">
        <div className="mb-3">
          <h5
            style={{
              marginBottom: "20px",
              fontSize: "15px",
              fontWeight: "600",
            }}
          >
            CANDIDATE INFORMATION
          </h5>
          <ProfilePhoto
            type="Recuritment"
            data={data}
            setProfileForm={setCandidateDetails}
            isEdit={isEdit ? isEdit : ""}
          />
        </div>
        <div className="row mb-3">
          {isEditData && (
            <div className="col-md-3">
              <label htmlFor="code" className="mb-1">
                Unique Id
              </label>
              <div>
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  value={candidateDetails?.uniqueId}
                  disabled
                />
              </div>
            </div>
          )}
          <div className="col-md-3">
            <label className="mb-1" htmlFor="firstName">
              Candidate Name <span className="color-red">*</span>
            </label>
            <div>
              <input
                type="text"
                className={`form-control ${inputDetailsError?.nameError ? "error-border" : ""
                  }`}
                name="name"
                onChange={(e) =>
                  handleBasicDetailsInput(e, "applicantDetails", "name")
                }
                value={applicantDetails?.name}
              />
              {!!inputDetailsError?.nameError && (
                <small className="text-danger">
                  {inputDetailsError?.nameError}
                </small>
              )}
            </div>
          </div>
          {
            <>
              <div className="col-md-3">
                <label className="mb-1" htmlFor="firstName">
                  Email <span className="color-red">*</span>
                </label>
                <div className="position-relative">
                  <input
                    type="text"
                    className={`form-control position-relative ${inputDetailsError?.emailError ? "error-border" : ""
                      }`}
                    name="email"
                    onChange={(e) =>
                      handleBasicDetailsInput(e, "applicantDetails", "email")
                    }
                    value={applicantDetails?.email}
                  />
                  <small
                    style={{ position: "absolute", top: "0px", right: "0px" }}
                  >
                    {!!applicantDetails?.email?.length &&
                      recruitmentTrackerUniqueEmailFetching && (
                        <RollingLoader />
                      )}
                  </small>
                  {!!inputDetailsError?.emailError && (
                    <small className="text-danger">
                      {inputDetailsError?.emailError}
                    </small>
                  )}
                </div>
                {recruitmentTrackerUniqueEmailMessage?.includes(
                  "email already exists"
                ) && (
                    <small className="text-danger">
                      Email is already in use!
                    </small>
                  )}
              </div>
              <div className="col-md-3">
                <label className="mb-1" htmlFor="lastName">
                  Phone <span className="color-red">*</span>
                </label>
                <div className="position-relative">
                  <input
                    type="text"
                    className={`form-control ${inputDetailsError?.phoneNumberError ? "error-border" : ""
                      }`}
                    name="phoneNumber"
                    onChange={(e) =>
                      handleBasicDetailsInput(
                        e,
                        "applicantDetails",
                        "phoneNumber"
                      )
                    }
                    value={applicantDetails?.phoneNumber}
                  />
                  <small
                    style={{ position: "absolute", top: "0px", right: "0px" }}
                  >
                    {" "}
                    {!!applicantDetails?.phoneNumber &&
                      recruitmentTrackerUniqueMobileFetching && (
                        <RollingLoader />
                      )}
                  </small>
                  {!!inputDetailsError?.phoneNumberError && (
                    <small className="text-danger">
                      {inputDetailsError?.phoneNumberError}
                    </small>
                  )}
                </div>
                {recruitmentTrackerUniqueMobileMessage?.includes(
                  "phone_number already exists"
                ) && (
                    <small className="text-danger">
                      Phone Number is already in use!
                    </small>
                  )}
              </div>


            </>
          }
        </div>
        <div className="row">
          <div className="col-md-3">
            <label className="mb-1" htmlFor="name">
              Years of Experience <span className="color-red">*</span>
            </label>
            <div>
              <input
                type="number"
                className={`form-control ${inputDetailsError?.yearsOfExperienceError
                    ? "error-border"
                    : ""
                  }`}
                name="yearsOfExperience"
                onChange={(e) =>
                  handleBasicDetailsInput(
                    e,
                    "applicantDetails",
                    "yearsOfExperience"
                  )
                }
                value={applicantDetails?.yearsOfExperience}
                onWheel={(event) => event.currentTarget.blur()}
              />
              {!!inputDetailsError?.yearsOfExperienceError && (
                <small className="text-danger">
                  {inputDetailsError?.yearsOfExperienceError}
                </small>
              )}
            </div>
          </div>
          <div className="col-md-3">
            <label className="mb-1" htmlFor="firstName">
              Linkedin Profile
            </label>
            <div>
              <input
                type="text"
                className={`form-control`}
                name="linkedinProfile"
                onChange={(e) =>
                  handleBasicDetailsInput(e, "applicantDetails", "")
                }
                value={applicantDetails?.linkedinProfile}
              />
            </div>
          </div>
          {
            <>
              <div className="col-md-3">
                <label className="mb-1" htmlFor="firstName">
                  Notice Period
                </label>
                <div>
                  <input
                    type="text"
                    className={`form-control ${inputDetailsError?.noticePeriodError ? "error-border" : ""
                      }`}
                    name="noticePeriod"
                    // onChange={(e) => handleBasicDetailsInput(e)}
                    onChange={(e) =>
                      handleBasicDetailsInput(
                        e,
                        "applicantDetails",
                        "noticePeriod"
                      )
                    }
                    value={applicantDetails?.noticePeriod}
                  // onWheel={(event) => event.currentTarget.blur()}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className="form-group mt-3 d-flex flex-column"
                  style={{ width: "340px" }}
                >
                  {applicantDetails?.resume &&
                    Object.keys(applicantDetails?.resume).length ? (
                    <div className="pointer d-flex flex-row mt-2">
                      <a
                        onClick={() =>
                          handleOpenPreview(applicantDetails?.resume)
                        }
                        target="_blank"
                        className="uploaded_file_name"
                      >
                        {applicantDetails?.resume?.file_name?.length > 20 ? (
                          <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 250 }}
                            overlay={
                              <Tooltip id="button-view-open-item">
                                {applicantDetails?.resume?.file_name}
                              </Tooltip>
                            }
                          >
                            <span>
                              {applicantDetails?.resume?.file_name.slice(0, 20)}
                              ...
                            </span>
                          </OverlayTrigger>
                        ) : (
                          <span>{applicantDetails?.resume?.file_name}</span>
                        )}
                      </a>
                      <div className="ml-2" onClick={handleDeleteResume}>
                        <TrashIcon />
                      </div>
                    </div>
                  ) : (
                    <button
                      className="btn btn btn-outline mt-2 w-50"
                      onClick={(e: any) => handleResumeToggleUploadModal(e)}
                    >
                      <span>+ Upload Resume</span>
                    </button>
                  )}
                </div>
              </div>
            </>
          }
        </div>

        <div className="row">

          <div className="col-md-3">
            <label className="mb-1" htmlFor="gender">
              Gender
            </label>
            <div className="position-relative">
              <Select
                className="dropdown"
                placeholder={"Select..."}
                value={applicantDetails?.gender}
                options={GENDER_STATUS}
                onChange={(e) =>
                  handleBasicDetailsInput(
                    e,
                    "applicantDetails",
                    "gender",
                    "dropdown"
                  )
                }
                isSearchable={true}
              />

            </div>
          </div>

          <div className="col-md-3">
            <label className="mb-1" htmlFor="qualification">
              Qualifications
            </label>
            <div className="position-relative">
              <Select
                className="dropdown"
                placeholder={"Select..."}
                value={applicantDetails?.qualification}
                options={finalQualificationList}
                isMulti
                isClearable
                onChange={(e) =>
                  handleBasicDetailsInput(
                    e,
                    "applicantDetails",
                    "qualification",
                    "dropdown"
                  )
                }
                isSearchable={true}
                isLoading={branchFetching && qualificationText?.length > 0}
                onMenuClose={() => setQualificationOffset(0)}
                onMenuScrollToBottom={(e: any) => checkQualificationBottom()}
                onInputChange={(e) => {
                  setQualificationText(e);
                }}
              />
            </div>
          </div>

          <div className="col-md-3">
            <label className="mb-1" htmlFor="skills">
              Skills
            </label>
            <div className="position-relative">
              <Select
                className="dropdown"
                placeholder={"Select..."}
                value={applicantDetails?.skill}
                options={finalSkillList}
                isMulti
                isClearable
                onChange={(e) => handleBasicDetailsInput(
                  e,
                  "applicantDetails",
                  "skill",
                  "dropdown"
                )
                }
                isSearchable={true}
                isLoading={branchFetching && skillsText?.length > 0}
                onMenuClose={() => setSkillsOffset(0)}
                onMenuScrollToBottom={(e: any) => checkSkillsBottom()}
                onInputChange={(e) => {
                  setSkillsText(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateInformation;
